/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import PropTypes from 'prop-types';
import React from 'react';
import FaPencilSquare from 'react-icons/lib/fa/pencil-square';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

// Components
import Button from '../../components/Button';

const propTypes = {
  setEditMode: PropTypes.func.isRequired,
  editMode: PropTypes.bool.isRequired,
};

const ControlButtons = ({ setEditMode, editMode }) => (
  <Container>
    {editMode && (
      <FormattedMessage
        id="controls.edit.info"
        description="Label for edit mode info"
        defaultMessage="Editing company info..."
      />
    )}

    {!editMode && (
      <Button onClick={setEditMode}>
        <EditIcon />
        <FormattedMessage
          id="controls.edit"
          description="Label for edit mode"
          defaultMessage="Edit company information"
        />
      </Button>
    )}
  </Container>
);

ControlButtons.propTypes = propTypes;

const Container = styled.div`
  margin-bottom: 24px;
`;

const EditIcon = styled(FaPencilSquare)`
  margin-right: 6px;
`;

export default ControlButtons;
